<template>
  <page layoutClass="manage-leaderboards">
    <h1>Manage Leaderboards</h1>

    <b-card class="shadow">
      <!-- selectable select-mode="range" selectedVariant="success" @row-selected="onItemSelected" -->
      <div class="d-flex justify-content-end align-items-middle">
        <!-- <b-dropdown size="sm" right variant="link" toggle-class="text-decoration-none pr-3" no-caret>
          <template v-slot:button-content>Filter</template>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here...</b-dropdown-item>
        </b-dropdown>
        <b-dropdown size="sm" right variant="link" toggle-class="text-decoration-none pr-3" no-caret>
          <template v-slot:button-content>Sort</template>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here...</b-dropdown-item>
        </b-dropdown>
        <b-dropdown size="sm" right variant="link" toggle-class="text-decoration-none pr-3" no-caret>
          <template v-slot:button-content><font-awesome-icon icon="ellipsis-h"/></template>
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here...</b-dropdown-item>
        </b-dropdown> -->
        <b-button :to="{ name: 'ManageLeaderboard', params: { leaderboardID: 'new' } }" size="sm" variant="primary"><font-awesome-icon icon="plus"/> New</b-button>
      </div>
      <b-table bordered hover striped responsive show-empty :busy="$apollo.queries.leaderboardConnections.loading" :fields="fields" :items="items">
        <template #cell(name)="{ value, item: { id: leaderboardID } }">
          <router-link class="font-weight-bold text-decoration-none pr-3" :to="{ name: 'ManageLeaderboard', params: { leaderboardID } }">{{ value }}</router-link>
        </template>
        <template #cell(type)="{ value }">
          <template v-if="value === 'INDIVIDUALS'"><font-awesome-icon icon="user" style="margin-left:3px"/></template>
          <template v-if="value === 'DEPARTMENTS'"><font-awesome-icon icon="users"/></template>
        </template>
      </b-table>
      <b-card class="border-0" body-class="d-flex flex-row p-3 justify-content-center align-items-center" v-if="leaderboardConnections && leaderboardConnections.page && leaderboardConnections.totalPages">
        <b-pagination class="m-0" v-model="filterPage" :total-rows="leaderboardConnections.totalPages" :per-page="filterLimit"/>
      </b-card>
    </b-card>
  </page>
</template>

<script>
import Page from '@/components/Page';
import formatDate from 'date-fns/format';
import ManageLeaderboardsQuery from '@/graphql/queries/ManageLeaderboards.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
  },
  data: () => ({
    filterPage: 1,
    filterLimit: 100,
    filterWhere: { status: 'ACTIVE' },
    filterOrder: 'CREATED_ASC',
  }),
  apollo: {
    leaderboardConnections: {
      query: ManageLeaderboardsQuery,
      variables() {
        const { filterPage, filterLimit, filterWhere, filterOrder } = this;
        return { filterPage, filterLimit, filterWhere, filterOrder };
      },
      update: ({ company: { leaderboardConnections } }) => leaderboardConnections,
      fetchPolicy: 'network-only',
      deep: true,
    },
  },
  metaInfo: {
    title: 'Manage Leaderboards',
  },
  computed: {
    ...mapRoot([ 'isRecruiterAdmin' ]),
    fields() {
      return [
        {
          key: 'name',
          label: 'Name',
        },
        {
          key: 'type',
          label: 'Type',
          thStyle: { width: '50px' },
        },
        {
          key: 'startDate',
          label: 'Start Date',
          formatter: value => value ? formatDate(value, 'DD/MMM') : '∞',
          thStyle: { width: '150px' },
        },
        {
          key: 'endDate',
          label: 'End Date',
          formatter: value => value ? formatDate(value, 'DD/MMM') : '∞',
          thStyle: { width: '150px' },
        },
        {
          key: 'membership',
          label: 'Membership',
          formatter({ everyone, departments, users } = {}) {
            if (everyone) {
              return '🌍';
            } else if (departments && departments.length) {
              return '👥';
            } else if (users && users.length) {
              return '👤';
            } else {
              return null;
            }
          },
          thStyle: { width: '150px' },
        },
        {
          key: 'prizes',
          label: 'Prizes',
          formatter({ first, second, third } = {}) {
            return (a => a.filter(b => typeof b === 'string').join(' '))([
              first ? '🥇' : null,
              second ? '🥈' : null,
              third ? '🥉' : null,
            ]);
          },
          thStyle: { width: '150px' },
        },
        {
          key: 'created',
          label: 'Created',
          formatter: value => formatDate(value, 'YYYY-MM-DD HH:mm'),
          thStyle: { width: '200px' },
        },
        {
          key: 'updated',
          label: 'Updated',
          formatter: value => formatDate(value, 'YYYY-MM-DD HH:mm'),
          thStyle: { width: '200px' },
        },
        {
          key: 'status',
          label: 'Status',
          formatter(value) {
            switch (value) {
              case 'ACTIVE': return 'Active';
              case 'INACTIVE': return 'Inactive';
              case 'DELETED': return 'Deleted';
              default: return value;
            }
          },
          thStyle: { width: '50px' },
        },
      ];
    },
    items() {
      const { edges } = this.leaderboardConnections || {};
      if (Array.isArray(edges) && edges.length) {
        return edges.filter(({ entry }) => entry && entry.id).map(({ entry }) => entry);
      } else {
        return [];
      }
    },
  },
  methods: {
    filterWhereUpdated(where) {
      this.filterWhere = where;
      this.filterPage = 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Recruiter/ManageLeaderboards.vue